<template lang="pug">
	.track-url-actions
		.track-url-events(v-if="_.size(data) > 0")
			.track-url-event(v-for="(eventObject, eventName) in data")
				.track-url-event-description(v-if="_.find(events, event => event.name === eventName)")
					.text-muted {{_.find(events, event => event.name === eventName).description}}
				.track-url-event-name
					select.custom-select.custom-select-sm(v-on:change="changeEvent(eventName, $event.target.value)")
						option(v-for="event in events" :selected="eventName === event.name" :value="event.name") {{event.name}}
					.track-url-event-remove(@click="removeEvent(eventName)")
						i.fa.fa-times
				.track-url-event-urls
					.track-url-event-url(v-for="(urlObject, index) in eventObject")
						input.form-control.form-control-sm(type="text" v-if="urlObject.trackingType !== 'matomo'" :placeholder="'put tracking code here...'" :value="urlObject.url" v-on:change="setUrl(eventName, $event.target.value, index, $event.target)")
						.track-url-event-url-setting.tracking-type
							span.text-muted.title Tracking type
							span
								select.custom-select.custom-select-sm(v-on:change="setUrlType(urlObject, $event.target.value)")
									option(:selected="urlObject.trackingType === 'mixpanel'" value="mixpanel") Mixpanel
									option(:selected="urlObject.trackingType === 'matomo'" value="matomo") Matomo
									option(:selected="urlObject.trackingType === 'prosper'" value="prosper") Prosper
									option(:selected="urlObject.trackingType === 'xhr'" value="xhr") XHR
									option(:selected="urlObject.trackingType === 'img'" value="img") Image
									option(:selected="urlObject.trackingType === 'script'" value="script") Script
						.track-url-event-url-setting.track-multiple
							span.text-muted.title Track only first event
							label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
								input.switch-input.form-check-input(type="checkbox" :checked="!urlObject.trackMultiple" @change="setUrlMultiple(urlObject, !$event.target.checked)")
								span.switch-slider(data-checked="On" data-unchecked="Off")
								span.switch-handle
					input.form-control.form-control-sm(type="text" :placeholder="eventObject.length > 0 ? 'put additional tracking code here...' : 'put tracking code here...'" v-on:change="setUrl(eventName, $event.target.value, null, $event.target)")
		.add-new-event
			select.custom-select.custom-select-sm(v-on:change="addNewEvent($event.target)")
				option(:selected="true" value="none") Add new event
				option(v-for="event in availableEvents" v-if="!data[event.name]" :selected="false" :value="event.name") {{event.name}}
</template>

<script>

	import Screen 						from './../../mixins/screen'

	import { Project } 					from './../../services/Project'
	import { Section } 					from './../../services/Section'
	import { Asset } 					from './../../services/Asset'
	import { Metadata } 				from './../../services/Metadata'

	export default {
		name: "SettingsContentTracking",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Project Changed", "Selected Project Settings Changed", "Settings Tab Changed", "Selected Project Sections Changed"]
		},
		props: ['setting'],
		data() {

			this.Project = Project;
			this.Settings = Settings;
			this._ = _;

			this.events = [];
			this.data = {};
			this.availableEvents = [];

			return {
				showed: true
			}

		},
		methods: {
			collectData() {

				if (!Project.SelectedProject) return;

				let settings = Settings.SettingsByProjectByCodename[Project.SelectedProject.id] || {};

				this.events = (settings['track-events'] || {}).value || [];


				if (!this.events.find(event => event.name === 'All tracking events')) {
					this.events.push({name: 'All tracking events'});
				}
				this.data = (settings['track-actions'] || {}).value || [];

				let sections = Section.getSelectedProjectSections();
				let projectSectionsTypes = new Set();

				let isPoll = false;
				let pollVariants = 2;
				for (let section of sections) {
					projectSectionsTypes.add(section.type);
					if (section.Data['include-poll']) {
						isPoll = true;
						pollVariants = section.Data['number-of-variants'] || 2;
					}
				}


				this.availableEvents = [];
				Object.values(this.events).forEach(event => {
					if (event.name === 'Poll Button Pressed') {
						if (isPoll) {
							for (let i = 0; i < pollVariants; i++) {
								let newEvent = _.cloneDeep(event);
								newEvent.name = 'Poll Button ' + (i + 1) + ' Pressed';
								//this.availableEvents.push(newEvent);
							}
						}
					}
					else if (!event.condition || (event.condition.sectionType.some(type => projectSectionsTypes.has(type)))) {
						this.availableEvents.push(event);
					}
				});

			},
			addNewEvent(el) {

				console.log('addNewEvent', el, el.value, this.data[el.value]);

				if (el.value === "none") return;

				if (this.data[el.value]) return;

				if (el.value === 'All tracking events') {

					this.availableEvents.forEach(event => {

						if (event.name !== 'All tracking events') {

							if (!this.data[event.name]) {

								this.data[event.name] = [{trackingType: 'matomo'}];

							}

						}

					});

					console.log('addNewEvent this.data', this.data);

					el.value = 'none';

					this.$forceUpdate();

					this.delaySave();

				}

				else {

					this.data[el.value] = [{trackingType: 'mixpanel'}];

					console.log('addNewEvent this.data', this.data);

					this.$forceUpdate();

					el.value = 'none';

					this.delaySave();
				}

			},
			changeEvent(oldEvent, newEvent) {

				if (this.data[newEvent]) return;

				this.data[newEvent] = this.data[oldEvent];

				delete this.data[oldEvent];

				this.$forceUpdate();

				this.delaySave();

			},
			removeEvent(eventName) {

				delete this.data[eventName];

				this.$forceUpdate();

				this.delaySave();

			},
			setUrl(eventName, url, index, el) {

				console.log(eventName, url, index, this.data);

				if (!this.data[eventName]) return;

				if (typeof index === "number") {

					if (!url) this.data[eventName].splice(index, 1);

					else this.data[eventName][index].url = url;

				} else {

					if (url) this.data[eventName].push({url, trackingType: 'mixpanel', trackMultiple: false});

					el.value = '';

				}

				this.$forceUpdate();

				this.delaySave();

			},
			setUrlType(urlObject, trackingType) {

				urlObject.trackingType = trackingType;

				this.$forceUpdate();

				this.delaySave();

			},
			setUrlMultiple(urlObject, trackMultiple) {

				urlObject.trackMultiple = trackMultiple;

				this.$forceUpdate();

				this.delaySave();

			},
			delaySave() {

				clearTimeout(this.saveTimeout);
				this.saveTimeout = setTimeout(() => {

					Settings.saveSettingValue(this.setting, this.data);

				}, 200);

			}
		}
	}
</script>

<style lang="sass">

	.track-url-actions
		display: flex
		justify-content: space-between
		user-select: none
		position: relative
		flex-direction: column

		.custom-select
			cursor: pointer
			color: #fff
			width: auto
			background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23ffffff' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px
			background-color: #343b41
			border: 1px solid #23282c
			margin-top: 0
			float: none !important

			&.selected
				background-color: #4dbd74

		.track-url-events
			position: relative
			margin-top: 5px
			border: 1px solid #23282c
			border-radius: 5px
			background-color: #343b41
			font-size: 12px
			overflow: hidden

			.track-url-event
				display: flex
				flex-direction: column
				position: relative
				user-select: none

				&:not(:first-child)
					border-top: 1px solid rgba(0, 0, 0, 0.1)

				&:hover
					background-color: #2f363c

				.track-url-event-description
					.text-muted
						font-size: 12px

				.track-url-event-name
					display: flex
					flex-direction: row
					justify-content: space-between
					padding: 0 5px 5px 5px

					.custom-select
						width: 315px

					.track-url-event-remove
						cursor: pointer
						transition: 0.2s
						padding: 4px 7px
						font-size: 14px
						color: #fff

						&:hover
							color: #20a8d8

						.fa-times
							padding-top: 8px

			.track-url-event-description
				padding: 5px 5px 0px 5px

			.track-url-event-urls
				padding: 5px 5px 0px 5px

				input.form-control
					margin-bottom: 5px

			.track-url-event-url

				.track-url-event-url-setting
					display: flex
					flex-direction: row
					justify-content: space-between
					align-items: center
					padding-bottom: 10px

					&.track-multiple
						border-bottom: 1px solid #23282c
						margin-bottom: 10px

</style>
